//
export const ASSET_BASE_PATH = "..";
